import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import { MenuGroup, Section } from '@atlaskit/menu';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { AgentPresenceMenuItem } from './AgentPresenceMenuItem.tsx';

const i18n = defineMessages({
	activeAgentsTitle: {
		id: 'team-presence.agent-group-menu.title',
		defaultMessage:
			'{count, plural, =0 {Active agents ({count})} one {Active agents ({count})} other {Active agents ({count})}}',
		description:
			'The text is shown as a title of a section inside of a menu. It describes the number of AI Agents actively on the page. {count} will be a literal number, like 0, 1, 2, 3, etc...',
	},
});

const styles = cssMap({
	root: {
		backgroundColor: token('elevation.surface.overlay'),
		boxShadow: token('elevation.shadow.overlay'),
		borderRadius: token('radius.small'),
		position: 'relative',
		width: '360px',
	},
});

export type AgentPresenceMenuProps = {
	agents: Agent[];
};

export const AgentPresenceMenu = ({ agents }: AgentPresenceMenuProps) => {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.root}>
			<MenuGroup maxHeight={480} minWidth={360} maxWidth={360}>
				<Section
					isScrollable
					title={formatMessage(i18n.activeAgentsTitle, { count: agents.length })}
				>
					{agents.map((agent) => (
						<AgentPresenceMenuItem key={agent.id} agent={agent} />
					))}
				</Section>
			</MenuGroup>
		</Box>
	);
};
